import { render, staticRenderFns } from "./PaperlessMessageBlock.vue?vue&type=template&id=44c0e87c&scoped=true&"
import script from "./PaperlessMessageBlock.vue?vue&type=script&lang=js&"
export * from "./PaperlessMessageBlock.vue?vue&type=script&lang=js&"
import style0 from "./PaperlessMessageBlock.vue?vue&type=style&index=0&id=44c0e87c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c0e87c",
  null
  
)

export default component.exports